import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuditLogIconService {
  /**
   * Gets the appropriate Lucide icon name for an audit log object type
   * @param objectType The entity type from the audit log
   * @param withPrefix Whether to include the 'lucide:' prefix (default: false)
   * @returns The icon name with or without prefix
   */
  getObjectTypeIcon(objectType?: string, withPrefix?: boolean): string {
    const iconName = this._getIconName(objectType);
    return withPrefix ? `lucide:${iconName}` : iconName;
  }

  private _getIconName(objectType?: string): string {
    switch ((objectType ?? '').toLowerCase()) {
      case 'integration':
        return 'plug';
      case 'policy':
        return 'scroll';
      case 'playbook':
        return 'square-play';
      case 'user':
        return 'user';
      case 'rule':
      case 'notes':
        return 'scroll';
      case 'violation':
        return 'alert-triangle';
      default:
        return 'scroll';
    }
  }
}
